import { useRouteError } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import auth from "shared/Auth0";
import { Button } from "components/ui/button";

function ErrorBoundary() {
  let error = useRouteError();

  const logout = (e: any) => {
    (e as any).preventDefault && (e as any).preventDefault();
    auth.logout();
  };
  return (
    <div className="h-screen w-screen flex items-center justify-center">
      <div className="p-4 rounded-xl bg-red-200 w-1/3 flex flex-col items-center text-center">
        <h1 className="text-red-500 text-3xl font-bold mb-4 w-full">
          {error instanceof Error ? error.message : "Sorry there was an error"}
        </h1>
        <FontAwesomeIcon
          icon="face-sad-cry"
          className="text-red-500 text-8xl mb-8"
        />
        <Button
          size="lg"
          onClick={(e) => logout(e)}
          type="button"
          variant="destructive"
        >
          Logout
        </Button>
      </div>
    </div>
  );
}

export default ErrorBoundary;
